export type DiffProps = {
  status: 'added' | 'deleted' | 'modified';
  tooltip?: string;
  previousValue?: string;
};

export const computeDiff = <T>(
  val: T | undefined,
  prev: T | undefined,
  comparator: (a: T | undefined, b: T | undefined) => boolean = (a, b) =>
    a === b,
  formatter: (v: T) => string = (v) => String(v),
): DiffProps | undefined => {
  if (comparator(val, prev)) return undefined;

  const valExists = val !== null && val !== undefined;
  const prevExists = prev !== null && prev !== undefined;

  if (!prevExists && valExists) {
    return { status: 'added' };
  }

  if (prevExists && !valExists) {
    return { status: 'deleted', previousValue: formatter(prev as T) };
  }

  if (valExists && prevExists) {
    return {
      status: 'modified',
      tooltip: `Changed from "${formatter(prev)}" to "${formatter(val)}"`,
    };
  }

  return undefined;
};
